// 스탬프투어 참여자(이름/연락처) 저장소
// 한 번 인증하면 localStorage 에 남겨 다음 접속부터 인증 없이 바로 메인으로 들어간다.
// (브라우저 설정으로 localStorage 를 못 쓰면 sessionStorage 로 대체)
const key = groupcode => 'stamp-user-' + groupcode

const read = (storage, k) => {
	try {
		return storage.getItem(k)
	} catch (e) {
		return null
	}
}

export function loadStampUser(groupcode) {
	const k = key(groupcode)
	let saved = read(window.localStorage, k)
	if (!saved) {
		// 이전 버전(sessionStorage 저장)으로 로그인한 참여자는 localStorage 로 옮겨 준다
		saved = read(window.sessionStorage, k)
		if (saved) saveRaw(k, saved)
	}
	if (!saved) return null
	try {
		const user = JSON.parse(saved)
		return user && user.phone ? user : null
	} catch (e) {
		return null
	}
}

function saveRaw(k, value) {
	try {
		window.localStorage.setItem(k, value)
	} catch (e) {
		window.sessionStorage.setItem(k, value)
	}
}

export function saveStampUser(groupcode, user) {
	saveRaw(key(groupcode), JSON.stringify({ name: user.name, phone: user.phone }))
}

export function clearStampUser(groupcode) {
	const k = key(groupcode)
	try {
		window.localStorage.removeItem(k)
	} catch (e) {
		// ignore
	}
	window.sessionStorage.removeItem(k)
}
